// import

import {useRef} from 'react';
import {CSSTransition} from 'react-transition-group';

import type {FrameProps} from './ModalFrame';
import {ModalFrame} from './ModalFrame';
import {useModals} from './useModals';

// types

type Props = Omit<FrameProps, 'frameRef'> & {
  open?: boolean;
};

// component

export function Modal(props: Props) {
  const {open = true, ...rest} = props;
  const {createModal} = useModals();
  const ref = useRef<HTMLElement>(null);

  return (
    <CSSTransition
      unmountOnExit
      in={open}
      nodeRef={ref}
      timeout={250}
    >
      {() => createModal((
        <ModalFrame {...rest} frameRef={ref} />
      ))}
    </CSSTransition>
  );
}
